export enum AccountType {
  AAD = "aad",
  MSA = "msa",
}

export type UserInfo = {
  emailAddress: string;
  accountType: AccountType;
  displayName?: string;
  avatarImage: string;
  firstName?: string;
  lastName?: string;
};

export type UserData = {
  isFetched: boolean;
  userInfo: UserInfo | undefined;
};
